import _ from 'lodash';
import React, { ComponentType } from 'react';
import { rbacRules } from './rbac-rules.c';
import { useUserRoles } from '../../../util/use-user-role';
import { LoadingScreen } from '../LoadingScreen';
import { UnauthorizedScreen } from '../UnauthorizedScreen';

/**
 * An HOC that handles whether or not the user can access a route.
 *
 * See: https://medium.com/better-programming/role-based-authorization-in-react-c70bb7641db4
 * Also see: Can.js for Components
 *
 */
export const Authorization = (allowedRoles: (keyof typeof rbacRules)[]) => (WrappedComponent: ComponentType) => {
  const WithAuthorization = () => {
    const { loading, roles } = useUserRoles();

    // if (loading) {
    //   return <LoadingScreen />;
    // } else if (_.intersection(allowedRoles, roles).length > 0) {
    //   return <WrappedComponent />;
    // } else {
    //   return <UnauthorizedScreen />;
    // }
    return <WrappedComponent />;
  };

  return WithAuthorization;
};
